"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
exports.__esModule = true;
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _text = require("@mmc/text");
var _clsx = _interopRequireDefault(require("clsx"));
var _mmcDataUtilities = _interopRequireDefault(require("@mmc-tools/mmc-data-utilities"));
var _commonCta = require("@mmc/common-cta");
var _configurationTextBlock = _interopRequireDefault(require("./configuration-text-block"));
var _accordionWrapper = _interopRequireDefault(require("./accordion-wrapper"));
var _configuratorLargeSummary = require("./configurator-large-summary.props/configurator-large-summary.propTypes");
var _configuratorLargeSummary2 = _interopRequireDefault(require("../styles/configurator-large-summary.css"));
var _DataUtils = new _mmcDataUtilities["default"](),
  handleNestedProp = _DataUtils.handleNestedProp;
var ConfiguratorLargeSummary = function ConfiguratorLargeSummary(_ref) {
  var data = _ref.data,
    theme = _ref.theme,
    config = _ref.config,
    rootUrl = _ref.rootUrl,
    direction = _ref.direction,
    changeModel = _ref.changeModel,
    changeColor = _ref.changeColor,
    changeFabric = _ref.changeFabric,
    changePackages = _ref.changePackages,
    changeAccessories = _ref.changeAccessories,
    market = _ref.market,
    summary = _ref.summary,
    addPriceDisclaimer = _ref.addPriceDisclaimer,
    priceDisclaimerId = _ref.priceDisclaimerId,
    disclaimerData = _ref.disclaimerData;
  var packagesSelections = data.packages || [];
  var accessoriesSelections = data.accessories || [];
  var fuelTypeSelections = data.fuelType || {};
  var driveTypeSelections = data.driveType || {};
  var transmissionTypeSelections = data.transmissionType || {};
  var additionalPriceGroup = {
    color: data.color ? data.color.price.value : 0,
    colorCode: data.color && data.color.code,
    fabric: data.fabric ? data.fabric.price.value : 0,
    fabricCode: data.fabric && data.fabric.code,
    "package": data.packages ? data.packages.reduce(function (a, b) {
      return a + b.price.value;
    }, 0) : 0,
    packageCodes: data.packages && data.factoryInstalledOptionCodes && data.packages.map(function (p) {
      return p.code;
    }).filter(function (v) {
      return !data.factoryInstalledOptionCodes.includes(v);
    }),
    accessory: data.accessories ? data.accessories.reduce(function (a, b) {
      return a + b.price.value;
    }, 0) : 0,
    accessoryCodes: data.accessories && data.accessories.map(function (a) {
      return a.code;
    }),
    destinationFees: data.totalPrice && data.totalPrice.fees ? data.totalPrice.fees.reduce(function (a, b) {
      return a + b.value;
    }, 0) : 0
  };
  var offersHeading = data.offersHeading,
    offerList = data.offerList,
    viewOfferCTA = data.viewOfferCTA,
    summaryFinanceData = data.summaryFinanceData;
  var isUS = market === 'us';
  var isCA = market === 'ca';
  var renderOffers = Array.isArray(offerList) && offerList.length !== 0 && isUS;
  return /*#__PURE__*/_react["default"].createElement("section", {
    className: (0, _clsx["default"])(theme['container-fluid'], _configuratorLargeSummary2["default"].summaryWrapper)
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: (0, _clsx["default"])(theme.row, _configuratorLargeSummary2["default"].sectionPadding)
  }, /*#__PURE__*/_react["default"].createElement(_configurationTextBlock["default"], {
    theme: theme,
    title: handleNestedProp(data, 'data.configurationTitle'),
    changeEvent: changeModel,
    changeText: handleNestedProp(data, 'data.changeText'),
    vehicle: handleNestedProp(data, 'data.vehicle'),
    model: handleNestedProp(data, 'data.model'),
    price: handleNestedProp(data, 'data.totalPrice'),
    copy: handleNestedProp(data, 'data.copyText'),
    rootUrl: rootUrl,
    configuratorCode: handleNestedProp(data, 'data.configuratorCode'),
    copyText: handleNestedProp(data, 'data.copyText'),
    shareDescription: handleNestedProp(data, 'data.shareDescription'),
    preferences: [fuelTypeSelections, driveTypeSelections, transmissionTypeSelections],
    config: config,
    direction: direction,
    addPriceDisclaimer: addPriceDisclaimer,
    priceDisclaimerId: summary.msrpDisclaimerId,
    disclaimerData: disclaimerData
  }), /*#__PURE__*/_react["default"].createElement(_accordionWrapper["default"], {
    theme: theme,
    title: handleNestedProp(data, 'data.customisationTitle'),
    color: handleNestedProp(data, 'data.color'),
    fabric: handleNestedProp(data, 'data.fabric'),
    customisationTitle: handleNestedProp(data, 'data.customisationTitle'),
    packages: packagesSelections,
    accessories: accessoriesSelections,
    includedPrice: handleNestedProp(data, 'data.includedText'),
    changeLink: handleNestedProp(data, 'data.changeText'),
    changeColor: changeColor,
    changeFabric: changeFabric,
    changePackages: changePackages,
    changeAccessories: changeAccessories,
    config: config,
    direction: direction,
    market: market,
    summaryFinanceData: summaryFinanceData,
    summary: summary,
    addPriceDisclaimer: addPriceDisclaimer,
    priceDisclaimerId: priceDisclaimerId,
    disclaimerData: disclaimerData,
    additionalPriceGroup: additionalPriceGroup
  })), renderOffers && /*#__PURE__*/_react["default"].createElement("div", {
    className: (0, _clsx["default"])(theme.row, _configuratorLargeSummary2["default"].offersWrapper)
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: (0, _clsx["default"])(theme['col-xs-12'], theme['col-sm-offset-1'], theme['col-sm-10'])
  }, /*#__PURE__*/_react["default"].createElement("h3", {
    className: theme.labelMedium
  }, offersHeading), /*#__PURE__*/_react["default"].createElement("div", {
    className: _configuratorLargeSummary2["default"].offersList
  }, offerList.map(function (offer) {
    return /*#__PURE__*/_react["default"].createElement("div", {
      key: offer.offerCode,
      className: _configuratorLargeSummary2["default"].offerCardContainer
    }, /*#__PURE__*/_react["default"].createElement("div", {
      className: "summary"
    }, /*#__PURE__*/_react["default"].createElement("p", {
      className: "textOffer"
    }, offer.offerType), /*#__PURE__*/_react["default"].createElement("p", {
      className: (0, _clsx["default"])(theme.headingThree, 'textHeadline')
    }, offer.descriptions[0].text)), /*#__PURE__*/_react["default"].createElement(_commonCta.CommonCta, {
      theme: theme,
      data: {
        priority: 'low',
        label: viewOfferCTA,
        url: offer.detailPageUrl
      },
      classes: [_configuratorLargeSummary2["default"].seeAllOffers]
    }));
  })))));
};
ConfiguratorLargeSummary.resourceType = function () {
  return 'LargeSummary_1_0_0';
};
ConfiguratorLargeSummary.displayName = 'ConfiguratorLargeSummary';
var _default = ConfiguratorLargeSummary;
exports["default"] = _default;